const KEY = "gamls_device_id";

const sha = async (text) => {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("").slice(0, 48);
};

const canvasTrait = () => {
  try {
    const c = document.createElement("canvas");
    c.width = 220; c.height = 40;
    const g = c.getContext("2d");
    g.textBaseline = "top"; g.font = "16px Arial"; g.fillStyle = "#E60000"; g.fillRect(0, 0, 110, 40);
    g.fillStyle = "#111"; g.fillText("GAMLS EventHub \u2713 2026", 4, 10);
    return c.toDataURL();
  } catch { return ""; }
};

const deviceId = () => {
  let id = "";
  try { id = localStorage.getItem(KEY) || ""; } catch { id = ""; }
  const fromCookie = document.cookie.split("; ").find((c) => c.startsWith(`${KEY}=`))?.split("=")[1];
  id = id || fromCookie || crypto.randomUUID();
  try { localStorage.setItem(KEY, id); } catch { /* storage blocked */ }
  document.cookie = `${KEY}=${id}; max-age=${60 * 60 * 24 * 730}; path=/; samesite=lax; secure`;
  return id;
};

const label = () => {
  const ua = navigator.userAgent;
  const browser = /Edg\//.test(ua) ? "Edge" : /OPR\//.test(ua) ? "Opera" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox" : /Safari\//.test(ua) ? "Safari" : "Browser";
  const os = /Android/.test(ua) ? "Android" : /iPhone|iPad/.test(ua) ? "iOS" : /Windows/.test(ua) ? "Windows" : /Mac OS X/.test(ua) ? "macOS" : /Linux/.test(ua) ? "Linux" : "Unknown OS";
  return `${browser} on ${os} · ${window.screen.width}×${window.screen.height}`;
};

export const deviceFootprint = async () => {
  const s = window.screen;
  const traits = [navigator.userAgent, navigator.language, navigator.platform, s.width, s.height, s.colorDepth, window.devicePixelRatio,
    Intl.DateTimeFormat().resolvedOptions().timeZone, navigator.hardwareConcurrency, navigator.deviceMemory, navigator.maxTouchPoints, canvasTrait()].join("|");
  return { device_id: deviceId(), device_print: await sha(traits), device_label: label() };
};
